import SmartComponent from './SmartComponent'
import SmartComponentLoader from './SmartComponentLoader'

const abundanceEngineExports = {
  SmartComponent,
  SmartComponentLoader
}

export default abundanceEngineExports
